<template>
  <v-card width="800">
    <v-card-title>Поиск и добавление организации</v-card-title>
    <v-card-text>
      <v-form ref="orgForm" lazy-validation v-model="valid">
          <v-text-field
              ref="inn"
              light
              v-model="organization.inn"
              :rules="[
                v => !!v || 'Поле обязательно для заполнения', 
                v => /^\d+$/.test(v) || 'Поле заполняется только цифрами', 
                v => v && v.length >= 10 || 'Поле должно состоять минимум из 10 цифр', 
              ]"
              label="ИНН"
              placeholder="ИНН"
              counter
              maxlength="13"
              append-icon="mdi-magnify"
              @click:append="onSearch"
              :loading="state === 'pending'" 
              :error-messages="error"
              required
          ></v-text-field>
          <v-text-field
              v-model="organization.fullName"
              :rules="[v => !!v || 'Поле обязательно для заполнения']"
              label="Полное название"
              placeholder="Полное название"
              clearable
              required
          ></v-text-field>
          <v-text-field
              v-model="organization.shortName"
              :rules="[v => !!v || 'Поле обязательно для заполнения']"
              label="Сокращенное название"
              placeholder="Сокращенное название"
              clearable
              required
          ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="success"
        class="mr-4"
        @click="onSave"
      >
        Сохранить
    </v-btn>
    </v-card-actions>
     <v-alert v-if="alertErrorText !== null" type="error">
      {{alertErrorText}}
    </v-alert>
  </v-card>
</template>

<script>
import {search} from '@/api/organizations';
import * as orgApi from '@/api/organizations';
import {validateErrToString} from '@/mixins/helper';
import {mapGetters, mapActions} from 'vuex';

const EMPTY_ORGANIZATION = {
    externalId: null,
    fullName: null,
    inn: null,
    shortName: null,
};
export default {
  name: 'OrganizationForm',
  props:{
    route_on_success_append: {
      type: Boolean,
      default: true
    }
  },
  mounted(){
  },
  data(){
    return {
      alertErrorText: null,
      error: null,
      state: "active",
      valid: true,
      organization: {
        externalId: null,
        fullName: null,
        inn: '',
        shortName: null,
      },
      onCloseNotify: null
    }
  },
  watch: {
    'organization.inn': function (newVal){
      if(typeof newVal === 'string' || newVal instanceof String){
        if(newVal.length === 10 || newVal.length === 12){
            this.onSearch();
        }else {
            this.organization = { ...EMPTY_ORGANIZATION, inn: this.organization.inn};
        }
      }
     },
     IS_SHOW: function(newVal){
        if( ! newVal && this.onCloseNotify ){
          this.onCloseNotify();
        }
     }
  },
    methods: {
      ...mapActions('workspace', ['INCREMENT_ORGANIZATION_COUNT', 'CHECKOUT_ORGANIZATION']),
      ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
      ...mapActions('organizationList', ['RELOAD']),
      async onSearch(){
        if( ! this.$refs.inn.validate() ){
          this.valid = false;
          return;
        }
        try{
          this.setError(null, 0);
          this.state = "pending";
          let result = await search({inn: this.organization.inn});
          if(Object.keys(result.data).length === 0){
            this.organization = { ...EMPTY_ORGANIZATION, inn: this.organization.inn};
            // this.setError(`Не найдено организации с ИНН ${this.organization.inn}. Внесите данные вручную`, 10000);
            return;
          }else{
            this.organization = { ...result.data };
          }
        }catch(e){
          this.setError('Произошла ошибка поиска. Попробуйте снова', 10000);
          console.log(e);
        }finally{
          this.state = "active";
        }
      },
      async onSave(){
          if( ! this.$refs.orgForm.validate() ){
            return;
          }
          this.alertErrorText = null;
          try{
              let result = await orgApi.workspaceAddOrganization(this.ID_WORK_SPACE, {
                  inn: this.organization.inn,
                  short_name: this.organization.shortName,
                  full_name: this.organization.fullName,
                  external_id: this.organization.externalId
              });
              this.SHOW_SUCCESS(result.data.message);
              this.INCREMENT_ORGANIZATION_COUNT();
              try{
                this.CHECKOUT_ORGANIZATION(result.data.organization.id);
              }catch(e){
                console.log(e);
              }
              if(this.route_on_success_append){
                this.onCloseNotify = () => this.$router.push({name: 'Organizations'});
                setTimeout(() => this.$router.push({name: 'Organizations'}), 5000);
              }
          }catch(e){
              let message = 'Ошибка добавления организации';
              if(undefined !== e.response.data.error){
                  this.alertErrorText = e.response.data.error;
              }else if(undefined !== e.response.data.errors && e.response.status == 422){
                  this.SHOW_ERROR(validateErrToString(e.response.data.errors));
              }else{
                  this.SHOW_ERROR(message);
              }
          }finally{
            this.RELOAD();
          }
      },
      setError(errText, timeout){
        this.error = errText;
        setTimeout(() => this.error = null, timeout);
      }
    },
    computed: {
      ...mapGetters( 'workspace', ['ID_WORK_SPACE']),
      ...mapGetters( 'notifications', ['IS_SHOW']),
    }
}
</script>